<template>
  <div>
    <page-navigate></page-navigate>
   
    <div class="activity-container">
      <!-- PC端视图 -->
      <div v-if="!isMobile" class="pc-version">
        <div class="image-wrapper">
          <!-- 简体中文内容 -->
          <template v-if="isSimplified">
            <div v-for="i in 11" :key="`pc-zh-cn-${i}`" class="image-section">
              <img :src="getImageUrl(`pc-zh-cn-${i}`)" alt="" class="section-image" />
              <template v-if="i === 5">
                <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=DjVMKhf5A0CxTnZDwyGIvQmkotM8Ij1Mrrox4Bh6eNZUQUxIU0ZVWlFLMTFQUDBZUDdFV0M5R1JaRC4u&origin=QRCode" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="top: 109%;left: 50%;transform: translateX(-50%);width: 19.02%;height: 11.5%;" title=""></a>
              </template>
              <template v-if="i === 9">
                <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=DjVMKhf5A0CxTnZDwyGIvQmkotM8Ij1Mrrox4Bh6eNZUQUxIU0ZVWlFLMTFQUDBZUDdFV0M5R1JaRC4u&origin=QRCode" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="bottom: -15%;left: 24%;width: 10.63%;height: 11.5%;" title=""></a>
              </template>
            </div>
          </template>
          <!-- 繁体中文内容 -->
          <template v-if="isTraditional">
            <div v-for="i in 8" :key="`pc-zh-tw-${i}`" class="image-section">
              <img :src="getImageUrl(`pc-zh-tw-${i}`)" alt="" class="section-image" />
              <template v-if="i === 6">
                <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=DjVMKhf5A0CxTnZDwyGIvdalgsXol_BMhC-_iyTr4ExUN0Q5UTE0ODJXSjlOU0FXOVZISEM1S1VRVi4u&origin=QRCode" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="top: 15%;left: 50%;transform: translateX(-50%);width: 19.02%;height: 15.5%;" title=""></a>
              </template>
            </div>
          </template>
        </div>
      </div>

      <!-- 移动端视图 -->
      <div v-if="isMobile" class="mobile-version">
        <div class="image-wrapper">
          <!-- 简体中文内容 -->
          <template v-if="isSimplified">
            <div v-for="i in 10" :key="`mobile-zh-cn-${i}`" class="image-section">
              <img :src="getImageUrl(`mobile-zh-cn-${i}`)" alt="" class="section-image" />
              <template v-if="i === 5">
                <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=DjVMKhf5A0CxTnZDwyGIvQmkotM8Ij1Mrrox4Bh6eNZUQUxIU0ZVWlFLMTFQUDBZUDdFV0M5R1JaRC4u&origin=QRCode" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="top: 66%;left: 50%;transform: translateX(-50%);width: 49%;height: 11.67%;" title=""></a>
              </template>
              <template v-if="i === 9">
                <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=DjVMKhf5A0CxTnZDwyGIvQmkotM8Ij1Mrrox4Bh6eNZUQUxIU0ZVWlFLMTFQUDBZUDdFV0M5R1JaRC4u&origin=QRCode" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="bottom: 47%; left: 50%;transform: translateX(-50%); width: 49%; height: 11.67%;" title="按钮2"></a>
              </template>
            </div>
          </template>
          <!-- 繁体中文内容 -->
          <template v-if="isTraditional">
            <div v-for="i in 8" :key="`mobile-zh-tw-${i}`" class="image-section">
              <img :src="getImageUrl(`mobile-zh-tw-${i}`)" alt="" class="section-image" />
              <template v-if="i === 6">
                <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=DjVMKhf5A0CxTnZDwyGIvdalgsXol_BMhC-_iyTr4ExUN0Q5UTE0ODJXSjlOU0FXOVZISEM1S1VRVi4u&origin=QRCode" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="top: 70%; left: 50%;transform: translateX(-50%); width: 49%; height: 15.67%;" title=""></a>
              </template>
            </div>
          </template>
        </div>
      </div>

    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
export default {
  name: 'MidAutumnFestival',
  data() {
    return {
      isMobile: false,
      imageBasePath: '/img/mid-autumn/', 
    };
  },
  computed: {
    isSimplified() { return this.$i18n.locale.toLowerCase() === 'zh'; },
    isTraditional() {
      const lang = this.$i18n.locale.toLowerCase();
      return lang === 'zh-tw' || lang === 'zh-hk' || lang === 'ct';
    },
  },
  created() {
    if (!this.isSimplified && !this.isTraditional) {
      this.$router.replace('/'); 
    }
  },
  methods: {
    handleResize() { this.isMobile = window.innerWidth < 995; },
    getImageUrl(name) { return `${this.imageBasePath}${name}.jpeg?v=1.2`; },
    toggleDebugMode(e) { if (e.key === 'F12') { e.preventDefault(); document.body.classList.toggle('debug-hotspots'); } }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('keydown', this.toggleDebugMode);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('keydown', this.toggleDebugMode);
  }
};
</script>

<style scoped>

.activity-container {
  width: 100%;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%; 
}


.image-section {
  position: relative;
  line-height: 0; 
  font-size: 0;
}

.section-image {
  width: 100%; 
  height: auto;
  display: block;
  user-drag: none;
  user-select: none;
  pointer-events: none;
}
.image-section:last-child {
  margin-bottom: -1px;
}
.hotspot {
  position: absolute;
  z-index: 2;
  cursor: pointer;
  background: transparent;
  transition: background 0.2s ease;
  border-radius: 8px;
}
.debug .hotspot{
  border:3px solid red;
}
</style>